import { Component, Shark, Utils } from "shark-mvc";
import templateContent from "./get-more-button.html";

class GetMoreComponent extends Component {
	constructor() {
		super("getMoreComponent");

		this.addTemplate("", templateContent);

		this.alertMinutesTreshold = 500;
		this.alertSecondsTreshold = 100;
		this.pageSize = 30;
		this.views = {};

		this.set({
			getMorePageSize: this.pageSize,
		});
	}

	loadAllItemsBtn_clickHandler () {
		const availableFurtherItems = Shark.get("__availableFurtherItems");

		if (availableFurtherItems > this.alertMinutesTreshold) {
			if (!confirm(`Hai richiesto il caricamento di ${availableFurtherItems} elementi, potrebbe volerci più di un minuto per ottenere i dati: vuoi continuare?`)) {
				return;
			}
		}
		else if (availableFurtherItems > this.alertSecondsTreshold) {
			if (!confirm(`Hai richiesto il caricamento di ${availableFurtherItems} elementi, potrebbero volerci parecchi secondi: vuoi continuare?`)) {
				return;
			}
		}

		if (Shark.activePage.loadAllItems) {
			Shark.activePage.loadAllItems();
		}
		else if (Shark.activePage.refreshList) {
			Shark.activePage.refreshList(this.getAllItemsRangeForView(Shark.activePage.id));
		}
	}

	loadMoreItemsBtn_clickHandler () {
		console.log(this.views);
		if (Shark.activePage.loadNextDataPage) {
			Shark.activePage.loadNextDataPage();
		}
		else if (Shark.activePage.refreshList) {
			Shark.activePage.refreshList(this.getNextPageRangeForView(Shark.activePage.id));
		}
	}

	getRangeForView (view, type) {
		if (this.views[view]) {
			let length = this.pageSize;

			switch (type) {
				case "all":
					length = 1000000;
				case "next":
					this.views[view].currentPage++;
					break;
			}

			return {
				first: this.pageSize * this.views[view].currentPage,
				length,
			};
		}
		else {

		}
	}

	getAllItemsRangeForView (view) {
		return this.getRangeForView(view, "all");
		// if (this.views[view]) {
		// 	this.views[view].currentPage++;

		// 	return {
		// 		first: this.pageSize * this.views[view].currentPage,
		// 		length: 1000000,
		// 	};
		// }
		// else {

		// }
	}

	getCurrentPageRangeForView (view) {
		return this.getRangeForView(view, "current");
		// if (this.views[view]) {
		// 	return {
		// 		first: this.pageSize * this.views[view].currentPage,
		// 		length: this.pageSize,
		// 	};
		// }
		// else {

		// }
	}

	getNextPageRangeForView (view) {
		return this.getRangeForView(view, "next");
		// if (this.views[view]) {
		// 	this.views[view].currentPage++;

		// 	return {
		// 		first: this.pageSize * this.views[view].currentPage,
		// 		length: this.pageSize,
		// 	};
		// }
		// else {

		// }
	}
}

const getMoreComponent = new GetMoreComponent();

Shark.registerComponent(getMoreComponent);

export default getMoreComponent;
